import { BaseNode } from './BaseNode';

export function WatermarkWriteNode({ data }: { data: { label: string; key?: string; value?: string } }) {
  return (
    <BaseNode
      type="watermark-write"
      label={data.label}
      lines={[
        { text: data.key, mono: true },
        data.value && { text: `= ${data.value}`, mono: true },
      ]}
    />
  );
}
